import { LoadingUtil } from 'lib-vue-v2/util';
import { useMessageBox } from "lib-vue-v2/composables";
import { Resource as CommonResource } from "@/models/Message/Resource/CommonResource";
import { AndroidSimpleAsset } from '@/views/Mobile/Android/GoogleAccountSetting/model/AndroidAsset';
import { BaseResponseDto } from "./BaseResponseDto";

// c#からくるレスポンス
interface GetAndroidDevicesResponseDto extends BaseResponseDto {
    devices: AndroidSimpleAsset[];
}

// メッセージ用
const { showMessageBox } = useMessageBox();

export default function useGetAndroidAssetPackage() {

    /**
     * IPC経由でAndroid端末情報を取得します。
     * @returns [処理の成否, 端末リスト]
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const executeAsync = async (_targetDivisionID: number[], _includeSubDivision: boolean): Promise<[boolean, AndroidSimpleAsset[]]> => {
        try {
            LoadingUtil.Start();

            const jsonResponse = await window.chrome?.webview?.hostObjects.class.AndroidDeviceInfo();
            if (jsonResponse === undefined) {
                showErrorMessage();
                return [false, []];
            }
            const response = JSON.parse(jsonResponse) as GetAndroidDevicesResponseDto;

            // failed
            if (!response.isSuccess) {
                showErrorMessage();
                return [false, []];
            }

            // success
            const devices = response.devices.map(device => ({
                ...device,
                // agentName が空（空文字、null、undefinedなど）の場合は computerName を設定
                agentName: device.agentName?.trim() ? device.agentName : device.computerName
            }));
            return [true, devices];
        }
        catch (error) {
            showErrorMessage();
            return [false, []];
        }
        finally {
            LoadingUtil.Stop();
        }
    }

    // エラーメッセージ表示
    const showErrorMessage = (): void => {
        // データの取得に失敗しました。
        showMessageBox(
            CommonResource.CommonResource.getInstance().getMsgInfo(
                CommonResource.MsgID.GetFailedErrorForMessage
            )
        );
    }

    // 外部公開
    return {
        executeAsync
    }
}
